import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/B0102/'),
    },
    {
      path: '/video',
      name: 'video',
      component: () => import('./views/Video/index'),
    },
    {
      path: '/videoIndex',
      name: 'videoIndex',
      component: () => import('./views/Video/VideoIndex'),
    },
    /*-- 焦建 --*/
    {
      path: '/B0401/new',
      name: 'NewB0401',
      component: () => import('./views/B0401/New'),
      meta: {
        permit: ['SHARP_SA_NEW'],
      },
    },
    {
      path: '/B0401/edit',
      name: 'EditB0401',
      component: () => import('./views/B0401/Edit'),
      meta: {
        permit: ['SHARP_SA_UPDATE'],
      },
    },
    {
      path: '/B0500',
      name: 'B0500',
      component: () => import('./views/B0500/'),
      meta: {
        permit: ['SHARP_DIM_SEARCH'],
      },
    },
    {
      path: '/B0600',
      name: 'B0600',
      component: () => import('./views/B0600/'),
      meta: {
        permit: ['SHARP_DIL_SEARCH'],
      },
    },
    {
      path: '/B0601',
      name: 'B0601',
      component: () => import('./views/B0601/'),
    },
    {
      path: '/B0602',
      name: 'B0602',
      component: () => import('./views/B0602/'),
    },
    {
      path: '/B0700',
      name: 'B0700',
      component: () => import('./views/B0700/'),
      meta: {
        permit: ['SHARP_AC_SEARCH'],
      },
    },
    {
      path: '/B0800',
      name: 'B0800',
      component: () => import('./views/B0800/'),
      meta: {
        permit: ['SHARP_DOC_SEARCH'],
      },
    },
    {
      path: '/B0801',
      name: 'B0801',
      component: () => import('./views/B0801/'),
    },
    {
      path: '/B0802',
      name: 'B0802',
      component: () => import('./views/B0802/'),
    },
    /*--焦建 */

    /*-- 唐永 --*/
    {
      path: '/B1101',
      name: 'B1101',
      component: () => import('./views/B1101'),
    },

    {
      path: '/B1200',
      name: 'B1200',
      component: () => import('./views/B1200/index'),
      meta: {
        permit: ['SHARP_FU_ARCHIVE_MONTHLY_ARAP_SEARCH'],
      },
    },
    {
      path: '/B1201',
      name: 'B1201',
      component: () => import('./views/B1201'),
      meta: {
        permit: ['SHARP_ARCHIVE_MONTHLY_ARAP_MANAGE'],
      },
    },
    {
      path: '/B1300',
      name: 'B1300',
      component: () => import('./views/B1300'),
      meta: {
        permit: ['SHARP_SIB_SEARCH'],
      },
    },
    {
      path: '/B1301',
      name: 'B1301',
      component: () => import('./views/B1301'),
      meta: {
        permit: ['SHARP_SIB_SEARCH'],
      },
    },
    {
      path: '/B1500',
      name: 'B1500',
      component: () => import('./views/B1500'),
      meta: {
        permit: ['SHARP_PO_SEARCH'],
      },
    },

    /*--唐永 */

    /*-- 汪成瀚 --*/
    {
      path: '/B1100',
      name: 'B1100',
      component: () => import('@/views/B1100'),
      meta: {
        permit: ['SHARP_LFS_SEARCH'],
      },
    },

    {
      path: '/B1000',
      name: 'B1000',
      component: () => import('@/views/B1000'),
      meta: {
        permit: ['SHARP_OFS_SEARCH'],
      },
    },
    {
      path: '/B1001/new',
      name: 'B1001New',
      component: () => import('@/views/B1001/New'),
      meta: {
        permit: ['SHARP_OFS_NEW'],
      },
    },
    {
      path: '/B1001/edit',
      name: 'B1001Edit',
      component: () => import('@/views/B1001/Edit'),
      meta: {
        permit: ['SHARP_OFS_EDIT'],
      },
    },
    {
      path: '/B0900',
      name: 'B0900',
      component: () => import('@/views/B0900'),
      meta: {
        permit: ['SHARP_EP_SEARCH'],
      },
    },
    {
      path: '/B0900/testPdf',
      name: 'B0900TestPdf',
      component: () => import('@/views/B0900/testEiajPdf'),
    },
    {
      path: '/M0090',
      name: 'M0090',
      component: () => import('@/views/M0090'),
      meta: {
        permit: ['SHARP_WS_SEARCH'],
      },
    },
    {
      path: '/M0091/new',
      name: 'NewM0091',
      component: () => import('@/views/M0091/New'),
    },
    {
      path: '/M0091/edit',
      name: 'EditM0091',
      component: () => import('./views/M0091/Edit.vue'),
    },
    {
      path: '/M0070',
      name: 'M0070',
      component: () => import('@/views/M0070'),
      meta: {
        permit: ['SHARP_COUNTRY_SEARCH'],
      },
    },
    {
      path: '/M0071/new',
      name: 'NewM0071',
      component: () => import('./views/M0071/New'),
    },
    {
      path: '/M0071/edit',
      name: 'EditM0071',
      component: () => import('./views/M0071/Edit.vue'),
    },
    {
      path: '/M0080',
      name: 'M0080',
      component: () => import('@/views/M0080'),
      meta: {
        permit: ['SHARP_PORT_SEARCH'],
      },
    },
    {
      path: '/M0081/new',
      name: 'NewM0081',
      component: () => import('./views/M0081/New.vue'),
    },
    {
      path: '/M0081/edit',
      name: 'EditM0081',
      component: () => import('./views/M0081/Edit.vue'),
    },
    {
      path: '/M0170',
      name: 'M0170',
      component: () => import('@/views/M0170'),
      meta: {
        permit: ['SHARP_WG_SEARCH'],
      },
    },
    {
      path: '/M0171/new',
      name: 'NewM0171',
      component: () => import('./views/M0171/New.vue'),
    },
    {
      path: '/M0171/edit',
      name: 'EditM0171',
      component: () => import('./views/M0171/Edit.vue'),
    },
    {
      path: '/M0180',
      name: 'M0180',
      component: () => import('@/views/M0180'),
      meta: {
        permit: ['SHARP_TM_SEARCH'],
      },
    },
    {
      path: '/M0181/new',
      name: 'NewM0181',
      component: () => import('./views/M0181/New.vue'),
    },
    {
      path: '/M0181/edit',
      name: 'EditM0181',
      component: () => import('./views/M0181/Edit.vue'),
    },
    {
      path: '/M0160',
      name: 'M0160',
      component: () => import('@/views/M0160'),
      meta: {
        permit: ['SHARP_SKU_SEARCH'],
      },
    },
    {
      path: '/M0161/new',
      name: 'M0161New',
      component: () => import('@/views/M0161/New'),
    },
    {
      path: '/M0161/edit',
      name: 'M0161Edit',
      component: () => import('@/views/M0161/Edit'),
    },
    {
      path: '/M0190',
      name: 'M0190',
      component: () => import('@/views/M0190'),
      meta: {
        permit: ['SHARP_CTR_SEARCH'],
      },
    },
    {
      path: '/M0191/new',
      name: 'NewM0191',
      component: () => import('./views/M0191/New.vue'),
    },
    {
      path: '/M0191/edit',
      name: 'EditM0191',
      component: () => import('./views/M0191/Edit.vue'),
    },
    {
      path: '/M0200',
      name: 'M0200',
      component: () => import('@/views/M0200'),
      meta: {
        permit: ['SHARP_PATTERN_SEARCH'],
      },
    },
    {
      path: '/M0201/new',
      name: 'M0201New',
      component: () => import('@/views/M0201/New'),
    },
    {
      path: '/M0201/edit',
      name: 'M0201Edit',
      component: () => import('@/views/M0201/Edit'),
    },
    {
      path: '/M0210',
      name: 'M0210',
      component: () => import('@/views/M0210'),
      meta: {
        permit: ['SHARP_BC_SEARCH'],
      },
    },
    {
      path: '/M0211/new',
      name: 'M0211New',
      component: () => import('./views/M0211/New.vue'),
    },
    {
      path: '/M0211/edit',
      name: 'EditM0211',
      component: () => import('./views/M0211/Edit.vue'),
    },
    {
      path: '/M0220',
      name: 'M0220',
      component: () => import('@/views/M0220'),
      meta: {
        permit: ['SHARP_CI_SEARCH'],
      },
    },
    {
      path: '/M0221/new',
      name: 'NewM0221',
      component: () => import('@/views/M0221/New'),
    },
    {
      path: '/M0221/edit',
      name: 'EditM0221',
      component: () => import('@/views/M0221/Edit'),
    },
    {
      path: '/M0230',
      name: 'M0230',
      component: () => import('@/views/M0230'),
      meta: {
        permit: ['SHARP_PRODUCT_SEARCH'],
      },
    },
    {
      path: '/M0231/new',
      name: 'M0231New',
      component: () => import('@/views/M0231/New'),
    },
    {
      path: '/M0231/edit',
      name: 'M0231Edit',
      component: () => import('@/views/M0231/Edit'),
    },
    // {
    //     path: '/C0250',
    //     name: 'M0250',
    //     component: () =>
    //         import ('@/views/M0250'),
    //     meta: {
    //         permit: ['SHARP_PRODUCT_SEARCH']
    //     }
    // },
    // {
    //     path: '/M0250/new',
    //     name: 'M0250New',
    //     component: () =>
    //         import ('@/views/M0250/New')
    // },
    // {
    //     path: '/M0250/edit',
    //     name: 'M0250Edit',
    //     component: () =>
    //         import ('@/views/M0250/Edit')
    // },
    {
      path: '/M0290',
      name: 'M0290',
      component: () => import('@/views/M0290/Index'),
      meta: {
        permit: ['SHARP_WAREHOUSE_SETTING_SEARCH'],
      },
    },
    {
      path: '/M0290/New',
      name: 'M0290New',
      component: () => import('@/views/M0290/New'),
    },
    {
      path: '/M0290/Edit',
      name: 'M0290Edit',
      component: () => import('@/views/M0290/Edit'),
    },
    {
      path: '/M0300',
      name: 'M0300',
      component: () => import('@/views/M0300/Index'),
      meta: {
        permit: ['SHARP_LONG_DISTANCE_ROUTE_SEARCH'],
      },
    },
    {
      path: '/M0300/New',
      name: 'M0300New',
      component: () => import('@/views/M0300/New'),
    },
    {
      path: '/M0300/Edit',
      name: 'M0300Edit',
      component: () => import('@/views/M0300/Edit'),
    },
    {
      path: '/M0260',
      name: 'M0260',
      component: () => import('@/views/M0260/Index'),
      meta: {
        permit: ['SHARP_FREETIME_SEARCH'],
      },
    },
    {
      path: '/M0260/New',
      name: 'M0260New',
      component: () => import('@/views/M0260/New'),
    },
    {
      path: '/M0260/Edit',
      name: 'M0260Edit',
      component: () => import('@/views/M0260/Edit'),
    },
    {
      path: '/M0270',
      name: 'M0270',
      component: () => import('@/views/M0270/Index'),
      meta: {
        permit: ['SHARP_PRODUCT_GROUP_SEARCH'],
      },
    },
    {
      path: '/M0270/New',
      name: 'M0270New',
      component: () => import('@/views/M0270/New'),
      meta: {},
    },
    {
      path: '/M0270/Edit',
      name: 'M0270Edit',
      component: () => import('@/views/M0270/Edit'),
      meta: {},
    },
    {
      path: '/M0280',
      name: 'M0280',
      component: () => import('@/views/M0280/Index'),
      meta: {
        permit: ['SHARP_CALENDER'],
      },
    },

    /*--汪成瀚 */

    /*-- 徐博凯 --*/
    {
      path: '/B0100',
      name: 'B0100',
      component: () => import('./views/B0100/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/B0101',
      name: 'B0101',
      component: () => import('./views/B0101/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/M0010',
      name: 'M0010',
      component: () => import('./views/M0010/index.vue'),
      meta: {
        permit: ['SHARP_UAS_SEARCH'],
      },
    },
    {
      path: '/M0011/new',
      name: 'M0011New',
      component: () => import('./views/M0011/New.vue'),
    },
    {
      path: '/M0011/edit',
      name: 'M0011Edit',
      component: () => import('./views/M0011/Edit.vue'),
    },
    {
      path: '/M0030',
      name: 'M0030',
      component: () => import('./views/M0030/index.vue'),
      meta: {
        permit: ['SHARP_COMPANY_SEARCH'],
      },
    },
    {
      path: '/M0031',
      name: 'M0031',
      component: () => import('./views/M0031/index.vue'),
    },
    {
      path: '/M0040',
      name: 'M0040',
      component: () => import('./views/M0040/index.vue'),
      meta: {
        permit: ['SHARP_DIVISION_SEARCH'],
      },
    },
    {
      path: '/M0041/new',
      name: 'M0041New',
      component: () => import('./views/M0041/New.vue'),
    },
    {
      path: '/M0041/edit',
      name: 'EditM0041',
      component: () => import('./views/M0041/Edit.vue'),
    },
    {
      path: '/M0100',
      name: 'M0100',
      component: () => import('./views/M0100/index.vue'),
      meta: {
        permit: ['SHARP_ER_SEARCH'],
      },
    },
    {
      path: '/M0101/new',
      name: 'NewM0101',
      component: () => import('./views/M0101/New.vue'),
    },
    {
      path: '/M0101/edit',
      name: 'EditM0101',
      component: () => import('./views/M0101/Edit.vue'),
    },
    {
      path: '/M0060',
      name: 'M0060',
      component: () => import('./views/M0060/index.vue'),
      meta: {
        permit: ['SHARP_INCOTERM_SEARCH'],
      },
    },
    {
      path: '/M0140',
      name: 'M0140',
      component: () => import('./views/M0140/index.vue'),
      meta: {
        permit: ['SHARP_IR_SEARCH'],
      },
    },
    {
      path: '/M0141/new',
      name: 'NewM0141',
      component: () => import('./views/M0141/New.vue'),
    },
    {
      path: '/M0141/edit',
      name: 'EditM0141',
      component: () => import('./views/M0141/Edit.vue'),
    },
    // {
    //     path: '/M0150',
    //     name: 'M0150',
    //     component: () =>
    //         import('./views/M0150/index.vue'),
    //     meta: {
    //         permit: ['SHARP_CCP_SEARCH']
    //     }
    // },
    {
      path: '/M0151/new',
      name: 'M0151New',
      component: () => import('./views/M0151/New.vue'),
    },
    {
      path: '/M0151/edit',
      name: 'EditM0151',
      component: () => import('./views/M0151/Edit.vue'),
    },
    {
      path: '/M0050',
      name: 'M0050',
      component: () => import('./views/M0050/index.vue'),
      meta: {
        permit: ['SHARP_UNIT_SEARCH'],
      },
    },
    {
      path: '/M0051/new',
      name: 'NewM0051',
      component: () => import('./views/M0051/New.vue'),
    },
    {
      path: '/M0051/edit',
      name: 'EditM0051',
      component: () => import('./views/M0051/Edit.vue'),
    },
    {
      path: '/M0130',
      name: 'M0130',
      component: () => import('./views/M0130/index.vue'),
      meta: {
        permit: ['SHARP_CHARGE_SEARCH'],
      },
    },
    ...'1,2,3,4,5,6,7,8,9,10,11,12,13'.split(',').map((i) => ({
      path: `/M0130/new/${i}`,
      name: `NewM0130-${i}`,
      component: () => import(`./views/M0130/Forms/New${i}.vue`),
    })),
    ...'1,2,3,4,5,6,7,8,9,10,11,12,13'.split(',').map((i) => ({
      path: `/M0130/edit/${i}`,
      name: `EditM0130-${i}`,
      component: () => import(`./views/M0130/Forms/Edit${i}.vue`),
    })),
    {
      path: '/M0121/new',
      name: 'NewM0121',
      component: () => import('./views/M0121/New.vue'),
    },
    {
      path: '/M0121/edit',
      name: 'EditM0121',
      component: () => import('./views/M0121/Edit.vue'),
    },
    {
      path: '/M0120',
      name: 'M0120',
      component: () => import('./views/M0120/index.vue'),
      meta: {
        permit: ['SHARP_CTT_SEARCH'],
      },
    },
    {
      path: '/M0241/new',
      name: 'NewM0241',
      component: () => import('./views/M0241/New.vue'),
    },
    {
      path: '/M0241/edit',
      name: 'EditM0241',
      component: () => import('./views/M0241/Edit.vue'),
    },
    // {
    //     path: '/M0240',
    //     name: 'M0240',
    //     component: () =>
    //         import('./views/M0240/index.vue'),
    //     meta: {
    //         permit: ['SHARP_CTT_SEARCH']
    //     }
    // },
    {
      path: '/M0110',
      name: 'M0110',
      component: () => import('./views/M0110/index.vue'),
      meta: {
        permit: ['SHARP_CT_SEARCH'],
      },
    },
    {
      path: '/M0111/new',
      name: 'NewM0111',
      component: () => import('./views/M0111/New.vue'),
    },
    {
      path: '/M0111/edit',
      name: 'EditM0111',
      component: () => import('./views/M0111/Edit.vue'),
    },
    {
      path: '/M0061/new',
      name: 'NewM0061',
      component: () => import('./views/M0061/New.vue'),
    },
    {
      path: '/M0061/edit',
      name: 'EditM0061',
      component: () => import('./views/M0061/Edit.vue'),
    },
    {
      path: '/B1400',
      name: 'B1400',
      component: () => import('./views/B1400/index.vue'),
      meta: {
        permit: ['SHARP_FU_WRITEOFF_SEARCH'],
      },
    },
    {
      path: '/B1401',
      name: 'B1401',
      component: () => import('./views/B1401/index.vue'),
    },
    {
      path: '/B0600/splitTabs',
      name: 'splitB0600',
      component: () => import('./views/B0600/SplitTabs.vue'),
      meta: {
        permit: ['SHARP_DIL_SPLIT'],
      },
    },
    /*--徐博凯 */

    /*-- 王劲松 --*/
    {
      path: '/B0200',
      name: 'B0200',
      component: () => import('./views/B0200'),
      meta: {
        permit: ['SHARP_QS_SEARCH'],
      },
    },
    {
      path: '/B0201/new',
      name: 'NewB0201',
      component: () => import('./views/B0201/New'),
      meta: {
        permit: ['SHARP_QS_NEW'],
      },
    },
    {
      path: '/B0201/edit',
      name: 'EditB0201',
      component: () => import('./views/B0201/Edit'),
      meta: {
        permit: ['SHARP_QS_EDIT'],
      },
    },
    {
      path: '/B0300',
      name: 'B0300',
      component: () => import('./views/B0300'),
      meta: {
        permit: ['SHARP_INV_SEARCH'],
      },
    },
    {
      path: '/B0301/new',
      name: 'NewB0301',
      component: () => import('./views/B0301/New'),
      meta: {
        permit: ['SHARP_INV_NEW'],
      },
    },
    {
      path: '/B0301/edit',
      name: 'EditB0301',
      component: () => import('./views/B0301/Edit'),
      meta: {
        permit: ['SHARP_INV_UPDATE'],
      },
    },
    {
      path: '/B0400',
      name: 'B0400',
      component: () => import('./views/B0400'),
      meta: {
        permit: ['SHARP_SA_SEARCH'],
      },
    },
    {
      path: '/B0102',
      name: 'B0102',
      component: () => import('./views/B0102'),
    },
    /*--王劲松 */
    {
      path: '/bulletin',
      name: 'Bulletin',
      component: () => import('./views/Bulletin'),
      meta: {
        permit: ['SHARP_MB_SEARCH'],
      },
    },
    {
      path: '/bulletin/new',
      name: 'NewBulletin',
      component: () => import('./views/Bulletin/New'),
    },
    {
      path: '/bulletin/edit',
      name: 'EditBulletin',
      component: () => import('./views/Bulletin/Edit'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
    },
    /* doc 4 sample screen design */
    {
      path: '/b0100/doc',
      name: 'b0100doc',
      component: () => import('./views/B0100/doc'),
    },
    {
      path: '/b0101/doc',
      name: 'b0101doc',
      component: () => import('./views/B0101/doc'),
    },
    {
      path: '/b0102/doc',
      name: 'b0102doc',
      component: () => import('./views/B0102/doc'),
    },
    {
      path: '/b0200/doc',
      name: 'b0200doc',
      component: () => import('./views/B0200/doc'),
    },
    {
      path: '/b0201/doc',
      name: 'b0201doc',
      component: () => import('./views/B0201/doc'),
    },
    {
      path: '/b0300/doc',
      name: 'b0300doc',
      component: () => import('./views/B0300/doc'),
    },
    {
      path: '/b0301/doc',
      name: 'b0301doc',
      component: () => import('./views/B0301/doc'),
    },
    {
      path: '/b0400/doc',
      name: 'b0400doc',
      component: () => import('./views/B0400/doc'),
    },
    {
      path: '/b0401/doc',
      name: 'b0401doc',
      component: () => import('./views/B0401/doc'),
    },
    {
      path: '/b0500/doc',
      name: 'b0500doc',
      component: () => import('./views/B0500/doc'),
    },
    {
      path: '/b0600/doc',
      name: 'b0600doc',
      component: () => import('./views/B0600/doc'),
    },
    {
      path: '/b0700/doc',
      name: 'b0700doc',
      component: () => import('./views/B0300/doc'),
    },
    {
      path: '/b0800/doc',
      name: 'b0800doc',
      component: () => import('./views/B0800/doc'),
    },
    {
      path: '/b0801/doc',
      name: 'b0801doc',
      component: () => import('./views/B0801/doc'),
    },
    {
      path: '/b0802/doc',
      name: 'b0802doc',
      component: () => import('./views/B0802/doc'),
    },
    {
      path: '/b0900/doc',
      name: 'b0900doc',
      component: () => import('./views/B0900/doc'),
    },
    {
      path: '/b1000/doc',
      name: 'b1000doc',
      component: () => import('./views/B1000/doc'),
    },
    {
      path: '/b1001/doc',
      name: 'b1001doc',
      component: () => import('./views/B1001/doc'),
    },
    {
      path: '/b1100/doc',
      name: 'b1100doc',
      component: () => import('./views/B1100/doc'),
    },
    {
      path: '/b1101/doc',
      name: 'b1101doc',
      component: () => import('./views/B1101/doc'),
    },
    {
      path: '/b1200/doc',
      name: 'b1200doc',
      component: () => import('./views/B1200/doc'),
    },
    {
      path: '/b1201/doc',
      name: 'b1201doc',
      component: () => import('./views/B1201/doc'),
    },
    {
      path: '/b1300/doc',
      name: 'b1300doc',
      component: () => import('./views/B1300/doc'),
    },
    {
      path: '/b1301/doc',
      name: 'b1301doc',
      component: () => import('./views/B1301/doc'),
    },
    {
      path: '/b1400/doc',
      name: 'b1400doc',
      component: () => import('./views/B1400/doc'),
    },
    {
      path: '/b1401/doc',
      name: 'b1401doc',
      component: () => import('./views/B1401/doc'),
    },
    {
      path: '/b1500/doc',
      name: 'b1500doc',
      component: () => import('./views/B1500/doc'),
    },
    {
      path: '/m0010/doc',
      name: 'm0010doc',
      component: () => import('./views/M0010/doc'),
    },
    {
      path: '/m0011/doc',
      name: 'm0011doc',
      component: () => import('./views/M0011/doc'),
    },
    {
      path: '/m0030/doc',
      name: 'm0030doc',
      component: () => import('./views/M0030/doc'),
    },
    {
      path: '/m0031/doc',
      name: 'm0031doc',
      component: () => import('./views/M0031/doc'),
    },
    {
      path: '/m0040/doc',
      name: 'm0040doc',
      component: () => import('./views/M0040/doc'),
    },
    {
      path: '/m0041/doc',
      name: 'm0041doc',
      component: () => import('./views/M0041/doc'),
    },
    {
      path: '/m0050/doc',
      name: 'm0050doc',
      component: () => import('./views/M0050/doc'),
    },
    {
      path: '/m0051/doc',
      name: 'm0051doc',
      component: () => import('./views/M0051/doc'),
    },
    {
      path: '/m0060/doc',
      name: 'm0060doc',
      component: () => import('./views/M0060/doc'),
    },
    {
      path: '/m0061/doc',
      name: 'm0061doc',
      component: () => import('./views/M0061/doc'),
    },
    {
      path: '/m0070/doc',
      name: 'm0070doc',
      component: () => import('./views/M0070/doc'),
    },
    {
      path: '/m0071/doc',
      name: 'm0071doc',
      component: () => import('./views/M0071/doc'),
    },
    {
      path: '/m0080/doc',
      name: 'm0080doc',
      component: () => import('./views/M0080/doc'),
    },
    {
      path: '/m0081/doc',
      name: 'm0081doc',
      component: () => import('./views/M0081/doc'),
    },
    {
      path: '/m0090/doc',
      name: 'm0090doc',
      component: () => import('./views/M0090/doc'),
    },
    {
      path: '/m0091/doc',
      name: 'm0091doc',
      component: () => import('./views/M0091/doc'),
    },
    {
      path: '/m0100/doc',
      name: 'm0100doc',
      component: () => import('./views/M0100/doc'),
    },
    {
      path: '/m0101/doc',
      name: 'm0101doc',
      component: () => import('./views/M0101/doc'),
    },
    {
      path: '/m0110/doc',
      name: 'm0110doc',
      component: () => import('./views/M0110/doc'),
    },
    {
      path: '/m0111/doc',
      name: 'm0111doc',
      component: () => import('./views/M0111/doc'),
    },
    {
      path: '/m0120/doc',
      name: 'm0120doc',
      component: () => import('./views/M0120/doc'),
    },
    {
      path: '/m0121/doc',
      name: 'm0121doc',
      component: () => import('./views/M0121/doc'),
    },
    {
      path: '/m0130/doc',
      name: 'm0130doc',
      component: () => import('./views/M0130/doc'),
    },
    {
      path: '/m0131/doc',
      name: 'm0131doc',
      component: () => import('./views/M0131/doc'),
    },
    {
      path: '/m0140/doc',
      name: 'm0140doc',
      component: () => import('./views/M0140/doc'),
    },
    {
      path: '/m0141/doc',
      name: 'm0141doc',
      component: () => import('./views/M0141/doc'),
    },
    {
      path: '/m0150/doc',
      name: 'm0150doc',
      component: () => import('./views/M0150/doc'),
    },
    {
      path: '/m0151/doc',
      name: 'm0151doc',
      component: () => import('./views/M0151/doc'),
    },
    {
      path: '/m0160/doc',
      name: 'm0160doc',
      component: () => import('./views/M0160/doc'),
    },
    {
      path: '/m0161/doc',
      name: 'm0161doc',
      component: () => import('./views/M0161/doc'),
    },
    {
      path: '/m0170/doc',
      name: 'm0170doc',
      component: () => import('./views/M0170/doc'),
    },
    {
      path: '/m0171/doc',
      name: 'm0171doc',
      component: () => import('./views/M0171/doc'),
    },
    {
      path: '/m0180/doc',
      name: 'm0180doc',
      component: () => import('./views/M0180/doc'),
    },
    {
      path: '/m0181/doc',
      name: 'm0181doc',
      component: () => import('./views/M0181/doc'),
    },
    {
      path: '/m0190/doc',
      name: 'm0190doc',
      component: () => import('./views/M0190/doc'),
    },
    {
      path: '/m0191/doc',
      name: 'm0191doc',
      component: () => import('./views/M0191/doc'),
    },
    {
      path: '/m0200/doc',
      name: 'm0200doc',
      component: () => import('./views/M0200/doc'),
    },
    {
      path: '/m0201/doc',
      name: 'm0201doc',
      component: () => import('./views/M0201/doc'),
    },
    {
      path: '/m0210/doc',
      name: 'm0210doc',
      component: () => import('./views/M0210/doc'),
    },
    {
      path: '/m0211/doc',
      name: 'm0211doc',
      component: () => import('./views/M0211/doc'),
    },
    {
      path: '/m0220/doc',
      name: 'm0220doc',
      component: () => import('./views/M0220/doc'),
    },
    {
      path: '/m0221/doc',
      name: 'm0221doc',
      component: () => import('./views/M0221/doc'),
    },
    {
      path: '/m0230/doc',
      name: 'm0230doc',
      component: () => import('./views/M0230/doc'),
    },
    {
      path: '/m0231/doc',
      name: 'm0231doc',
      component: () => import('./views/M0231/doc'),
    },
    /** ---杨宁--- */
    {
      path: '/M0020',
      name: 'M0020',
      component: () => import('./views/M0020/index.vue'),
      meta: {
        permit: [
          'SHARP_AUTHORITY_NEW',
          'SHARP_AUTHORITY_EDIT',
          'SHARP_AUTHORITY_DETAIL',
        ],
      },
    },
    {
      path: '/M0021/new',
      name: 'NewM0021',
      component: () => import('./views/M0021/New.vue'),
    },
    {
      path: '/M0021/edit',
      name: 'EditM0021',
      component: () => import('./views/M0021/Edit.vue'),
    },
    {
      path: '/M0022',
      name: 'M0022Index',
      component: () => import('./views/M0022/index.vue'),
    },
    {
      path: '/M2500',
      name: 'M2500',
      component: () => import('@/views/M2500/Index'),
    },
    {
      path: '/M2500/edit',
      name: 'M2500_edit',
      component: () => import('@/views/M2500/Edit'),
    },
    {
      path: '/M2500/New',
      name: 'M2500_new',
      component: () => import('@/views/M2500/New'),
    },
    {
      path: '/B0101/CreatePassword',
      name: 'createPassword',
      component: () => import('./views/B0101/CreatePassword.vue'),
    },
    {
      path: '/B1600',
      name: 'B1600',
      component: () => import('./views/B1600/index.vue'),
      meta: {
        permit: ['SHARP_BCE_SEARCH'],
      },
    },
    {
      path: '/B1601',
      name: 'B1601',
      component: () => import('./views/B1601/index.vue'),
      meta: {
        permit: ['SHARP_BCI_SEARCH'],
      },
    },
    {
      path: '/B1800',
      name: 'B1800',
      component: () => import('./views/B1800/index.vue'),
      meta: {
        permit: ['SHARP_PCS_SEARCH'],
      },
    },
    {
      path: '/B1700',
      name: 'B1700',
      component: () => import('./views/B1700/index.vue'),
      meta: {
        permit: [
          'SHARP_DR_SUM_EIAJ',
          'SHARP_PSCS_FREIGHT',
          'SHARP_DR_SUM_SUPPLIER',
          'SHARP_DR_SUM_LOCAL_FEE',
        ],
      },
    },
    {
      path: '/B1801',
      name: 'B1801',
      component: () => import('./views/B1801/index.vue'),
    },
    {
      path: '/B1900',
      name: 'B1900',
      component: () => import('./views/B1900/newIndex.vue'),
      meta: {
        permit: ['SHARP_PSCS_SEARCH'],
      },
    },
    {
      path: '/B1900-new',
      name: 'B1900-new',
      component: () => import('./views/B1900/newIndex.vue'),
      meta: {
        permit: ['SHARP_PSCS_SEARCH'],
      },
    },
    {
      path: '/B1901',
      name: 'B1901',
      component: () => import('./views/B1901/index.vue'),
    },
    {
      path: '/B20000',
      name: 'B20000',
      component: () => import('./views/B20000/index.vue'),
      meta: {
        permit: ['SHARP_PSCS_SEARCH'],
      },
    },
    {
      path: '/B20010',
      name: 'B20010',
      component: () => import('./views/B20010/index.vue'),
    },
    {
      path: '/B0501',
      name: 'B0501',
      component: () => import('./views/B0501/index.vue'),
    },
    {
      path: '/maintain',
      name: 'Maintain',
      component: () => import('./views/Maintain/index.vue'),
    },
    {
      path: '/B0603',
      name: 'B0603',
      component: () => import('./views/B0603/index.vue'),
    },
    {
      path: '/mail/monitor',
      name: 'mailMonitor',
      component: () => import('./views/Mail/Index.vue'),
    },
    {
      path: '/b2b/operation/monitor',
      name: 'operationMonitor',
      component: () => import('./views/B2B/Operation.vue'),
    },
    {
      path: '/b2b/adjust-container-history',
      name: 'adjustContainerHistory',
      component: () => import('./views/B2B/AdjustContainerHistory.vue'),
    },
    {
      path: '/b2b/sa/monitor',
      name: 'b2bSAMonitor',
      component: () => import('./views/B2B/SAMonitor.vue'),
    },
    {
      path: '/b2b/sa/tracking',
      name: 'b2bSATracking',
      component: () => import('./views/B2B/SATracking.vue'),
    },
    {
      path: '/b2b/po/monitor',
      name: 'b2bPoMonitor',
      component: () => import('./views/B2B/POMonitor.vue'),
    },
    {
      path: '/reset-pwd',
      name: 'resetPwd',
      component: () => import('./views/Pwd/ResetPassword.vue'),
    },
    {
      path: '/foreign/write-off',
      name: 'foreignWriteOff',
      component: () => import('./views/B2B/ForeignWriteOffMonitor.vue'),
    },
    {
      path: '/jpy/write-off',
      name: 'jpyWriteOff',
      component: () => import('./views/B2B/JpyWriteOffMonitor.vue'),
    },
    {
      path: '/B2000',
      name: 'B2000',
      component: () => import('./views/B2000/index.vue'),
      meta: {
        permit: ['SHARP_FU_ARAP_MANUAL_SEARCH'],
      },
    },
    {
      path: '/B2001',
      name: 'B2001',
      component: () => import('./views/B2001/index.vue'),
      meta: {
        permit: ['SHARP_FU_ARAP_MANUAL_SEARCH'],
      },
    },
    {
      path: '/B2002',
      name: 'B2002',
      component: () => import('./views/B2002/index.vue'),
      meta: {
        permit: ['SHARP_FU_ARAP_MANUAL_SEARCH'],
      },
    },
    {
      path: '/B1202',
      name: 'B1202',
      component: () => import('./views/B1202/index.vue'),
    },
    {
      path: '/B2100',
      name: 'B2100',
      component: () => import('./views/B2100/index.vue'),
      meta: {
        permit: ['SHARP_REQUEST_BOOK_ISSUE_SEARCH'],
      },
    },
    {
      path: '/B2200',
      name: 'B2200',
      component: () => import('./views/B2200/index.vue'),
      meta: {
        permit: ['BOOKING_SEARCH'],
      },
    },
    {
      path: '/B2201/new',
      name: 'B2201New',
      component: () => import('./views/B2201/New.vue'),
      meta: {},
    },
    {
      path: '/B2201/edit',
      name: 'B2201Edit',
      component: () => import('./views/B2201/Edit.vue'),
      meta: {},
    },
    {
      path: '/B2300',
      name: 'B2300',
      component: () => import('./views/B2300/Index.vue'),
      meta: {
        permit: ['RESERVE_WAREHOUSE_SEARCH'],
      },
    },
    {
      path: '/B2300/reserve-forecast',
      name: 'B2300ReserveForecast',
      component: () => import('./views/B2300/ReserveForecast.vue'),
      meta: {
        permit: ['RESERVE_WAREHOUSE_SEARCH'],
      },
    },
    {
      path: '/B2300/warehouse-setting',
      name: 'B2300WarehouseSetting',
      component: () => import('./views/B2300/WarehouseSetting.vue'),
    },
    {
      path: '/B2300/warehouse-detail',
      name: 'B2300WarehouseDetail',
      component: () => import('./views/B2300/WarehouseDetail.vue'),
    },
    {
      path: '/B2300/adjust-containers',
      name: 'B2300AdjustContainers',
      component: () => import('./views/B2300/AdjustContainers.vue'),
    },
    {
      path: '/B2300/auto-set',
      name: 'B2300AutoSet',
      component: () => import('./views/B2300/AutoSetContainers.vue'),
    },
    {
      path: '/B2300/excluded-instruction',
      name: 'B2300ExcludedInstruction',
      component: () => import('./views/B2300/ExcludedInstruction.vue'),
    },
    {
      path: '/replaced',
      name: 'Replaced',
      component: () => import('./views/B0600/ReplacedDialog.vue'),
      meta: {},
    },
    {
      path: '/B2400',
      name: 'B2400',
      component: () => import('./views/B2400/index.vue'),
      meta: {},
    },

    ///////////////////////TDOC/////////////////////////////
    {
      path: '/t-doc',
      name: 'Tdoc',
      component: () => import('./views/Tdoc/index.vue'),
      meta: {
        permit: ['TDOC_SEARCH'],
      },
    },
    {
      path: '/t-doc/New',
      name: 'TdocNew',
      component: () => import('./views/Tdoc/New.vue'),
      meta: {},
    },
    {
      path: '/t-doc/Edit',
      name: 'TdocEdit',
      component: () => import('./views/Tdoc/Edit.vue'),
      meta: {},
    },
    {
      path: '/t-doc/SendMail',
      name: 'TdocSendMail',
      component: () => import('./views/Tdoc/SendMail.vue'),
      meta: {},
    },
    {
      path: '/t-doc/MailHistory',
      name: 'TdocMailHistory',
      component: () => import('./views/Tdoc/MailHistory.vue'),
      meta: {},
    },
    {
      path: '/monitor/shipment',
      name: 'MonitorShipment',
      component: () => import('./views/B2B/SaInterfaceMonitor.vue'),
      meta: {},
    },
    {
      path: '/monitor/eiaj',
      name: 'MonitorEiaj',
      component: () => import('./views/B2B/EiajInterfaceMonitor.vue'),
      meta: {},
    },
  ],
})
export default router
